export default {
  styleOverrides: {
    root: {
      borderBottom: '1px solid var(--color-divider)',
      color: 'var(--color-text-primary)',
      padding: '12px 16px',
    },

    head: {
      fontWeight: 600,
      color: 'var(--color-text-secondary)',
      backgroundColor: 'var(--color-bg-secondary)',
      borderBottom: '2px solid var(--color-divider)',
    },

    body: {
      fontSize: '0.875rem',
    },
  },
};
